export default __webpack_public_path__ + "static/media/medium.f0b01254.svg";